export const DEFAULTLANGUAGE = "en_US";
export const PREFERREDLANGUAGENOTPROVIDED = "Not Provided";
export const translationType = {
    NONE:'None',
    EVERBRIDGE:'Everbridge',
    GOOGLE:'Google'
};

export const metaTags = [
    {
        name: 'robots',
        content: 'noindex,nofollow',
    },
    {
        name: 'google-site-verification',
        content: 'pnfp0A7cRAz4MFdc4U2q6b04fA0gtkn4cLP21yjzis8',
    }
]

export const environmentMap = {
  "member-dev3.everbridge.net": "dev3",
  "member-qa1.everbridge.net": "qa1",
  "member.everbridge.eu": "prod-eu",
  "member.everbridge.net": "us",
};

export const MF_REMOTE_ENTRIES = {
    dev3: "https://mf-dev3.everbridge.net/remoteEntries.js",
    qa1: "https://mf-qa1.everbridge.net/remoteEntries.js",
    prod_us: "https://mf.everbridge.net/remoteEntries.js",
    prod_eu: "https://mf-eu.everbridge.net/remoteEntries.js",
};

export const eb360MapURI = {
    dev3: "https://mf-dev3.everbridge.net/eb360-map-control/remoteEntry.js",
    qa1: "https://mf-qa1.everbridge.net/eb360-map-control/remoteEntry.js",
    prod: "https://mf.everbridge.net/eb360-map-control/remoteEntry.js",
    prod_eu: "https://mf.everbridge.eu/eb360-map-control/remoteEntry.js",
};
